import { ArticleMeta } from "~/.server/content.server";
import { DateDisplay } from "~/components/date-display";

interface ArticleHeaderProps {
  article: ArticleMeta;
}

export function ArticleHeader({ article }: ArticleHeaderProps) {
  return (
    <div className="mb-6">
      <div className="flex items-center gap-2 text-sm text-slate-500 mb-2">
        <DateDisplay 
          timestamp={article.created_timestamp}
          className="text-sm text-slate-500"
        />
        <span className="text-xs px-2 py-1 rounded-full bg-slate-100 text-slate-700">
          {article.category}
        </span>
      </div>
      
      <h1 className="text-3xl font-bold mb-3">{article.title}</h1>
      
      <p className="text-xl text-slate-600 dark:text-slate-300 mb-6">
        {article.summary}
      </p>
      
      <div className="flex flex-wrap gap-2 mb-8">
        {article.tags.map(tag => (
          <span 
            key={tag} 
            className="px-3 py-1 bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-300 text-xs rounded-full"
          >
            {tag}
          </span>
        ))}
      </div>
    </div>
  );
} 